import React, { lazy } from 'react';
import { AlertTriangle, CheckCircle2, Phone } from 'lucide-react';
export function Safety() {
  const checklist = ['Pull over safely if the damage blocks your view or distracts you while driving.', 'Do not drive if loose glass, spreading cracks or blocked visibility make the vehicle unsafe.', 'Avoid touching shattered glass with bare hands.', 'Cover broken side or rear windows only if it can be done safely and temporarily.', 'Take a clear photo of the damaged glass if possible.', "Call Kosin's Glass or request an urgent quote.", 'Have your vehicle year, make, model and insurance information ready.', 'Ask whether ADAS calibration may be needed after windshield replacement.'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-257">
      <div className="max-w-7xl mx-auto" data-id="element-258">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-259">
          {/* Image column */}
          <div className="lg:col-span-5 lg:sticky lg:top-6" data-id="element-260">
            <div className="relative" data-id="element-261">
              <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200 aspect-[4/3]" data-id="element-262">
                <img src="https://cdn.magicpatterns.com/uploads/k5qz2jn6pcyaSqWodjEn6Z/%E2%80%9CWhat_To_Do.png" alt="Driver's view through a windshield with a large impact crack spreading across the glass, showing why visibility damage requires urgent attention" className="w-full h-full object-cover" loading="lazy" data-id="element-263" />
              </div>
              <div className="hidden sm:flex absolute -bottom-5 -left-5 bg-white border border-slate-200 shadow-md rounded-xl px-4 py-3 items-center gap-3" data-id="element-264">
                <div className="bg-brand-redLight p-2 rounded-lg" data-id="element-265">
                  <AlertTriangle className="w-5 h-5 text-brand-red" data-id="element-266" />
                </div>
                <div data-id="element-267">
                  <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide" data-id="element-268">
                    Visibility Damage
                  </div>
                  <div className="text-sm font-bold text-slate-900" data-id="element-269">
                    Do Not Drive
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Checklist column */}
          <div className="lg:col-span-7" data-id="element-270">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-271">
              <div className="p-6 sm:p-8 border-b border-slate-100" data-id="element-272">
                <div className="text-xs font-bold uppercase tracking-wider text-brand-red mb-2" data-id="element-273">
                  Safety First
                </div>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 leading-tight tracking-tight" data-id="element-274">
                  What To Do When Your{' '}
                  <span className="text-brand-red" data-id="element-275">
                    Windshield or Car Window Breaks
                  </span>
                </h2>
              </div>

              <div className="p-6 sm:p-8" data-id="element-276">
                <ul className="space-y-4 mb-8" data-id="element-277">
                  {checklist.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-278">
                      <span className="shrink-0 mt-0.5 w-6 h-6 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-279">
                        <CheckCircle2 className="w-3.5 h-3.5 text-brand-red" strokeWidth={3} data-id="element-280" />
                      </span>
                      <span className="text-slate-700 leading-relaxed" data-id="element-281">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <div className="pt-4 border-t border-slate-100" data-id="element-282">
                  <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm w-full sm:w-auto" data-id="element-283">
                    <Phone className="w-5 h-5" data-id="element-284" />
                    Call Kosin's Glass for Emergency Help
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}